import { i18n } from '@/i18n';

export interface Separator {
  id: number;
  type: 'separator';
}

export interface NavRouteItem {
  text: string;
  legacy?: string;
  to?: string;
  parentRouteName?: string;
}

export interface Route {
  id: string;
  text: string;
  icon?: string;
  routeName?: string;
  legacy?: string;
  to?: string;
  parentRouteName?: string;
  items?: NavRouteItem[];
  target?: string;
}

export const publicRoutes = [
  {
    id: 'features',
    to: '/blog',
    text: i18n.global.t('sidebar.features'),
  },
  {
    id: 'resources',
    legacy: 'https://help.erank.com/',
    text: i18n.global.t('sidebar.resources'),
  },
  {
    id: 'plans',
    text: i18n.global.t('sidebar.plans'),
    to: 'plans',
  },
] as (Route | Separator)[];

export const registeredRoutes = [
  {
    icon: 'home',
    id: 'dashboard',
    text: i18n.global.t('sidebar.dashboard'),
    to: '/dashboard',
  },
  {
    icon: 'search',
    id: 'keyword-research',
    text: i18n.global.t('sidebar.keyword_research.title'),
    items: [
      {
        parentRouteName: 'keyword-research', // TODO
        text: i18n.global.t('sidebar.keyword_research.keyword_tool'),
        to: '/keyword-tool',
      },
      {
        to: '/bulk-keyword-tool',
        text: i18n.global.t('sidebar.keyword_research.bulk_keyword_tool'),
      },
      {
        to: '/keyword-lists',
        text: i18n.global.t('sidebar.keyword_research.keyword_lists'),
      },
      {
        parentRouteName: 'rank-checker',
        to: '/rank-checker',
        text: i18n.global.t('sidebar.keyword_research.rank_checker'),
      },
    ],
  },
  {
    icon: 'bar-chart',
    id: 'competitor',
    text: i18n.global.t('sidebar.competitor_research.title'),
    items: [
      {
        parentRouteName: 'competitor-sales',
        to: '/competitor-sales',
        text: i18n.global.t('sidebar.competitor_research.competitor_sales'),
      },
      {
        parentRouteName: 'top-sellers',
        to: '/top-sellers',
        text: i18n.global.t('sidebar.competitor_research.top_sellers'),
      },
      {
        parentRouteName: 'shop-info',
        to: '/shop-info',
        text: i18n.global.t('sidebar.competitor_research.shop_info'),
      },
      {
        parentRouteName: 'categories',
        to: '/category',
        text: i18n.global.t('sidebar.competitor_research.category'),
      },
    ],
  },
  {
    icon: 'tag',
    id: 'listing-optimization',
    text: i18n.global.t('sidebar.listing_optimization.title'),
    items: [
      {
        to: '/listings/active',
        text: i18n.global.t('sidebar.listing_optimization.listing_audits'),
      },
      {
        parentRouteName: 'health-check',
        text: i18n.global.t('sidebar.listing_optimization.health_check'),
        to: '/health-check',
      },
      {
        text: i18n.global.t('sidebar.listing_optimization.al_listing_helper'),
        to: '/ai-listing-helper',
      },
      {
        text: i18n.global.t('sidebar.listing_optimization.compare_listings'),
        to: '/compare-listings',
      },
      {
        to: '/listings/active?ref=side-menu',
        text: i18n.global.t('sidebar.listing_optimization.changes'),
      },
      {
        to: '/draft',
        text: i18n.global.t('sidebar.listing_optimization.draft_listings'),
      },
      {
        to: '/expired',
        text: i18n.global.t('sidebar.listing_optimization.expired_listings'),
      },
      {
        text: i18n.global.t('sidebar.listing_optimization.create_video'),
        to: '/create-video',
      },
    ],
  },
  {
    icon: 'shop-icon',
    id: 'shop',
    text: i18n.global.t('sidebar.shop_insights.title'),
    items: [
      {
        text: i18n.global.t('sidebar.shop_insights.traffic_stats'),
        to: '/traffic-stats',
      },
      {
        parentRouteName: 'spotted-on-etsy',
        text: i18n.global.t('sidebar.shop_insights.spotted_on_etsy'),
        to: '/spotted-on-etsy',
      },
      {
        parentRouteName: 'tags',
        text: i18n.global.t('sidebar.shop_insights.tag_report'),
        to: '/tags',
      },
      {
        parentRouteName: 'sales-map',
        to: '/sales-map',
        text: i18n.global.t('sidebar.shop_insights.sales_map'),
      },
      {
        text: i18n.global.t('sidebar.shop_insights.spell_checker'),
        to: '/spell-checker',
      },
      {
        text: i18n.global.t('sidebar.shop_insights.delivery_status'),
        to: '/delivery-status',
      },
    ],
  },
  {
    icon: 'trend',
    id: 'trends',
    text: i18n.global.t('sidebar.trends.title'),
    items: [
      {
        parentRouteName: 'trend-buzz',
        text: i18n.global.t('sidebar.trends.trend_buzz'),
        to: '/trend-buzz',
      },
      {
        parentRouteName: 'trending',
        text: i18n.global.t('sidebar.trends.monthly_trends'),
        to: '/trending',
      },
    ],
  },
  {
    icon: 'tools-icon',
    id: 'tools',
    text: i18n.global.t('sidebar.tools.title'),
    items: [
      {
        text: i18n.global.t('sidebar.tools.calculators'),
        to: '/calculators',
      },
      {
        parentRouteName: 'calendar',
        text: i18n.global.t('sidebar.tools.calendar'),
        to: '/calendar',
      },
      {
        to: '/shortcut',
        text: i18n.global.t('sidebar.tools.shortcut_button'),
      },
    ],
  },
  {
    icon: 'globe',
    id: 'globe',
    text: i18n.global.t('sidebar.sites.title'),
    to: '/shopbuzz',
  },
  {
    id: 1,
    type: 'separator',
  },
  {
    icon: 'cog',
    id: 'settings',
    to: '/settings',
    text: i18n.global.t('sidebar.settings'),
  },
] as (Route | Separator)[];
